import { CH_HOME_FEATURE } from '@propertypal/shared/src/constants/content-hub';
import { ConvertedContentHubArticle } from '@propertypal/shared/src/types/strapi/overrides';
import getArticleCategory from '@propertypal/shared/src/utils/getArticleCategory';
import React from 'react';
import PageNumbers from '../search/PageNumbers';
import ContentHubArticleBox from './ContentHubArticleBox';
import { Container, Grid, Wrapper } from './ContentHubArticleGrid.style';
import ContentHubBreadcrumbs from './ContentHubBreadcrumbs';

interface Props {
  categorySlug: string;
  subCategorySlug: string;
  url: string;
  articles: ConvertedContentHubArticle[];
  page: number;
  totalPages: number;
  homeLink: string;
}

const ContentHubArticleGrid = (props: Props) => {
  const subCategoryName =
    (props.articles.length && props.articles[0].attributes.subCategories?.data[0].attributes.subCategory) || '';

  return (
    <Container>
      <Wrapper>
        <ContentHubBreadcrumbs
          breadcrumbs={[
            CH_HOME_FEATURE ? { title: 'Home', url: props.homeLink } : undefined,
            { title: getArticleCategory(props.categorySlug), url: `/${props.categorySlug}` },
            { title: subCategoryName, url: `/${props.categorySlug}/${props.subCategorySlug}` },
          ]}
          mb={30}
        />

        <h2>{subCategoryName}</h2>

        <Grid>
          {props.articles.map((article) => (
            <ContentHubArticleBox key={article.id} article={article} />
          ))}
        </Grid>

        {props.totalPages > 1 && (
          <PageNumbers currentPage={props.page} totalPages={props.totalPages} currentUrl={props.url} useQueryString />
        )}
      </Wrapper>
    </Container>
  );
};

export default ContentHubArticleGrid;
